import React from "react";
import { HomePhoneProduct } from "../../../../../types/homePhone";
import { formatCurrency } from "../../../../../utils/currency";
import PRODUCT_DETAIL from "../constants";

interface PriceBlockProps {
  product: Pick<HomePhoneProduct, "price" | "currency">;
}

const PriceBlock: React.FC<PriceBlockProps> = ({ product }) => (
  <div className="pd-price-row">
    <span className="pd-price">
      {formatCurrency(product.price || 0, product.currency)}
    </span>
    <span className="pd-price-unit">{PRODUCT_DETAIL.LABELS.PRICE_UNIT}</span>
  </div>
);

export default PriceBlock;
